// import { PageHeader } from "@ant-design/pro-layout";
import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { CaseDetailsMessagesContainer } from '../components/case-details-messages-container';
import { Helmet } from 'react-helmet';

export const CaseMessagesIdentityVerificationCase: React.FC = () => {
  const params = useParams();
  return (
    <>
      <Helmet>
        <title>Case - Messages</title>
      </Helmet>
      <SubPageLayout>
        <CaseDetailsMessagesContainer caseId={params.caseId as string} />
      </SubPageLayout>
    </>
  );
};
